export default {
  jsonLabel: 'JSON',
  pathLabel: 'Path',
  fieldLabel: 'Field',
  insert: 'Insert'
}
